import Api from './ApiService'

export default {
    get(keyword, pageNumber, sort) {
        return Api().get(`autor?keyword=${keyword}&pageNumber=${pageNumber}&sort=${sort}`);
    },
    getOne(id) {
        return Api().get(`autor/${id}`);
    },
    create(data) {
        return Api().post(`autor`, data);
    },
    update(data) {
        return Api().put(`autor/${data.id}`, data);
    }
}